import clsx from 'clsx';
import moment from 'moment-jalaali';
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { VisaStatus } from 'src/components/VisaStatus/VisaStatus';
import { ChevronDown } from 'src/icons/icons';
import { VisaFlyItem, VisaItemType } from 'src/types'
import { createFileURL } from 'src/utils/new';

const FieldComponent = ({ title, value, colSpan = 2 }: { title: string, value: string, colSpan?: number }) => <div className='flex flex-col gap-2 items-start'>
    <span className='text-gray-700 text-xs'>{title} </span>
    <span className='border-b border-b-gray-100'>{value}</span>
</div>


export const CrewsList = ({ record, onSelectCrews, selectedCrews }: { record: VisaItemType &  {nationality: Array<{ id: string, en_name: string, fa_name: string }> }, selectedCrews: string[], onSelectCrews: (persons: Array<string>) => void }) => {

    const [isOpen, setIsOpen] = useState<boolean>(false)

    const { t } = useTranslation();

  const lng = useSelector((state) => (state as any).common.lng)


    const { crews } = record

    const user = useSelector((state) => (state as any).user.user)

    const isAgent = user?.role_key == "agent"

    const toggleAll = (state: boolean) => {
        if (state) onSelectCrews([])
        else onSelectCrews(crews.map(i => i.crew_id))

    }

    const isAllSelected = selectedCrews.length == crews.length

    return (
        <div className='flex flex-col gap-2'>
            <div className='flex flex-row gap-2 items-center justify-center border bg-white p-2 rounded-lg cursor-pointer' onClick={() => setIsOpen(!isOpen)}>
                <span> {t('View')}  {crews.length}  {t('crew')}</span>
                <ChevronDown className={clsx('size-5 transition-all duration-300', isOpen ? 'rotate-180' : '')} />
            </div>

            {isOpen && <>

                {isAgent && <label className={clsx('flex flex-row gap-2 items-center rounded-lg  border p-2 bg-white justify-start cursor-pointer', isAllSelected ? 'border-primary-300' : '')}>
                    <input type='checkbox' className='rounded' checked={isAllSelected} onChange={({ target: { checked } }) => !checked ? toggleAll(true) : toggleAll(false)} />
                    <span>{t('Select')} {t('All')} {t('crews')}</span>
                </label>}


                {crews
                    .map(({ crew, job, id, crew_id , visa_job }, index) => {


                        if (!crew) return <span className='text-center text-gray-500'>{t('CrewIsEmpty')}</span>


                        else {

                            const isCrewSelected = selectedCrews.indexOf(crew_id) != -1
                            const { name, last_name, nationality, cdc_expire, passport_expire, picture } = crew
                            return <label htmlFor={crew_id} className='flex flex-row gap-2 items-center bg-white border rounded-lg p-2 cursor-pointer relative'>

                                <div className={clsx('rounded-full w-5 h-5  bg-gray-100 border flex flex-row justify-center items-center pt-1', isAgent ? 'absolute right-2 top-3' : '')}>{index + 1}</div>
                                {isAgent && <input
                                    id={crew_id}
                                    type='checkbox'
                                    className='rounded'
                                    checked={isCrewSelected}
                                    onChange={({ target: { checked } }) => !checked ? onSelectCrews(selectedCrews.filter(i => i != crew_id)) : onSelectCrews([...selectedCrews, crew_id])}
                                />}


                                <div className='absolute left-0 top-2 px-2 bg-green-100 font-bold border border-green-400 rounded-lg rounded-l-none'>
                                    <VisaStatus status={record.status} />
                                </div>


                                <div className={clsx('h-48 flex  w-[1px]', isCrewSelected ? 'bg-primary-300' : 'bg-gray-100')}></div>


                                <div className='flex flex-col gap-3'>
                                    <FieldComponent title='نام و نام خانوادگی' value={`${name} ${last_name}`} />
                                    <FieldComponent title='شغل' value={visa_job?.[0]?.name ?? '-'} />
                                    <FieldComponent title='ملیت' value={lng =='fa' ? record.nationality.find(n=>n.id==nationality)?.fa_name ??'' :record.nationality.find(n=>n.id==nationality)?.en_name ?? ''} />
                                    <div className='flex flex-row gap-8'>
                                        <FieldComponent title='انقضا پاسپورت' value={moment(passport_expire).format('YYYY/MM/DD')} />
                                        <FieldComponent title='انقضا CDC' value={moment(cdc_expire).format('YYYY/MM/DD')} />
                                    </div>

                                </div>

                                {picture ? <img src={createFileURL(picture)} className='w-24 sm:w-28 md:w-32 aspect-square  absolute left-2 top-14 border rounded-full object-cover' />
                                    : <div className='w-24 sm:w-28 md:w-32 aspect-square  absolute left-2 top-14 border rounded-full object-cover bg-gray-100' />}

                            </label>
                        }
                    })}</>}

        </div>
    )
}
